import { isArray, uniqBy } from 'lodash'

const state = {
  fileIdMap: {},
  groupIdMap: {}
}

const mutations = {
  ADD_AUTH_FILES_BY_API: (state, apiData) => {
    let authAttachmentList = []
    if (
      isArray(apiData) &&
      apiData.some((item) => item.authAttachmentList?.length)
    ) {
      authAttachmentList = apiData
        .map((item) => item.authAttachmentList)
        .filter((value) => !!value)
        .flat()
    }
    if (apiData?.authAttachmentList?.length) {
      authAttachmentList = apiData.authAttachmentList || []
    }
    ADD_FILE(state, authAttachmentList)
  },

  DELETE_AUTH_FILE_BY_IDS: (state, fileIds = []) => {
    const deleteFileIds = fileIds
      .toString()
      .split(',')
      .map((item) => Number(item))
    deleteFileIds.forEach((fileId) => {
      if (state.fileIdMap[fileId]) {
        delete state.fileIdMap[fileId]
      }
    })
  },

  DELETE_AUTH_FILE_BY_GROUP_ID: (state, groupId) => {
    if (state.groupIdMap[groupId]) {
      delete state.groupIdMap[groupId]
    }
  },

  CLEAR_FILE: (state) => {
    state.fileIdMap = {}
    state.groupIdMap = {}
  }
}

function ADD_FILE(state, authAttachmentList = []) {
  if (!isArray(authAttachmentList)) {
    return
  }
  authAttachmentList.forEach((file) => {
    if (file.groupId) {
      if (state.groupIdMap[file.groupId]?.length) {
        state.groupIdMap[file.groupId].push(file)
        state.groupIdMap[file.groupId] = uniqBy(
          state.groupIdMap[file.groupId],
          'attachmentId'
        )
      } else {
        state.groupIdMap[file.groupId] = [file]
      }
    }
    state.fileIdMap[file.attachmentId] = file
  })
}

export default {
  namespaced: true,
  state,
  mutations
}
